
import { Component, Vue } from "vue-property-decorator";
import NewsRelease from "@/template/newDetails/NewsRelease.vue";
@Component
export default class NewsReleaseDetails extends NewsRelease {}
